import React, { useContext } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { QtyOnHandValue } from "../../shared/QtyOnHandValue/QtyOnHandValue";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import UserService from "../../../services/UserService";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    row: IOrder_ItemUI;
};

export const LineItemQtyInventoryDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const showInventoryDetails = UserService.showInventoryDetails(supplierModel, userModel);

    const inventoryDetail =
        props.row.Catalog_Item?.has_inventory && showInventoryDetails ? (
            <div className="d-flex justify-content-end border-top border-bottom">
                <OwLabel title={"qoh"} postText={":"} className="me-2" />
                <QtyOnHandValue catalogItem={props.row.Catalog_Item} />
            </div>
        ) : null;

    return inventoryDetail;
};
